export const useSearchPixel = (searchTerm: string) => {
  if (!window.fbq) return;

  window.fbq('track', 'Search', {
    search_string: searchTerm,
    content_category: 'products',
  });
};
